<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9,8C9,7.72,8.89,7.47,8.71,7.29C8.71,7.29,4.71,3.29,4.71,3.29C4.53,3.11,4.28,3,4,3C3.45,3,3,3.45,3,4C3,4.28,3.11,4.53,3.29,4.71C3.29,4.71,6.59,8,6.59,8C6.59,8,3.3,11.29,3.3,11.29C3.11,11.47,3,11.72,3,12C3,12.55,3.45,13,4,13C4.28,13,4.53,12.89,4.71,12.71C4.71,12.71,8.71,8.71,8.71,8.71C8.89,8.530000000000001,9,8.280000000000001,9,8C9,8,9,8,9,8ZM13.71,7.29C13.71,7.29,9.71,3.29,9.71,3.29C9.530000000000001,3.11,9.280000000000001,3,9,3C8.45,3,8,3.45,8,4C8,4.28,8.11,4.53,8.29,4.71C8.29,4.71,11.59,8,11.59,8C11.59,8,8.3,11.29,8.3,11.29C8.11,11.47,8,11.72,8,12C8,12.55,8.45,13,9,13C9.280000000000001,13,9.530000000000001,12.89,9.71,12.71C9.71,12.71,13.71,8.71,13.71,8.71C13.89,8.530000000000001,14,8.280000000000001,14,8C14,7.72,13.89,7.47,13.71,7.29C13.71,7.29,13.71,7.29,13.71,7.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DoubleChevronRight',
} as DefineComponent
</script>
